import React, { ChangeEvent, useCallback, useMemo } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { validateRule } from '../validation';

interface FormControllerProps<FormModel extends FieldValues> {
  name: Path<FormModel>;
  control: Control<FormModel>;
  as: React.ComponentType<any>;
  rules?: string | object;
  onChange?: (e: any, value: any) => any;

  [x: string]: any;
}

function FormControllerComponent<FormModel extends FieldValues>(
  {
    name,
    control,
    as: Element,
    rules,
    onChange: onChangeUp,
    ...rest
  }: FormControllerProps<FormModel>) {

  const rulesObject = useMemo(() => {
    if (!rules) return undefined;
    const validated = typeof rules === 'string' ? validateRule(rules) : undefined;
    return validated || rules;
  }, [rules]);

  const onChangeProxy = useCallback(
    (e: ChangeEvent<HTMLInputElement>, value: any) => {
      if (onChangeUp) {
        return onChangeUp(e, value);
      }
      let valueResult: any = '';
      if (
        e?.target !== undefined &&
        e.target.value !== undefined &&
        e.target.value !== null &&
        e.target.type !== 'checkbox'
      ) {
        valueResult = e.target.value;
      } else if (value !== undefined && value !== null) {
        valueResult = value;
      }
      return valueResult;
    },
    [onChangeUp],
  );
  return (
    <Controller
      name={name}
      control={control}
      rules={rulesObject}
      render={({ field: { onChange, onBlur, value, name }, fieldState }) => (
        <Element
          {...rest}
          name={name}
          value={value}
          onBlur={onBlur}
          error={fieldState.error || undefined}
          onChange={(e: ChangeEvent<HTMLInputElement>, val: any) =>
            onChange(onChangeProxy(e, val))
          }
        />
      )}
    />
  );
}

export const FormController = FormControllerComponent as unknown as typeof FormControllerComponent;
